<template>
    <div style='height:100%' @click="containerMode&&upload()">
        <template v-if="!containerMode">
            <div v-if="type === 'image'">
                <div class="text-center"><ilabel :label="label" /></div>
                <!-- uploadedFile && ['jpg','jpeg','png','gif','bmp','tiff','svg'].indexOf(uploadedFile.ext)!=-1  -->
                <div class="image-preview text-center" :style="{backgroundImage:`url(${uploadedFile&&uploadedFile.url || noImagePlaceholder})`}">
                    <div class="fader">
                        <span v-if="uploadedFile&&uploadedFile.url">
                            <span class="img-ctrl fal fa-search" @click="showPreview=true"></span>
                        &nbsp;
                        </span>
                        <span class="img-ctrl fal fa-upload" @click="upload" ></span>
                    </div>
                </div>
            </div>
            <div v-else>
                <ilabel :label="label" />
                <div v-if='uploadedFile'><span :class="'fal fa-'+fileIcons[uploadedFile.ext]" v-if="fileIcons[uploadedFile.ext]"/> {{uploadedFile&&uploadedFile.name}}</div>
                <btn i='upload' l="Загрузить" @press="upload" />
                <div v-if="value" class="uploaded-file">
                    <a :href="value" target="_blank" >{{value}}</a>
                </div>
                <br>
            </div>
        </template>
        <slot v-if="containerMode" />
        <div class="image-preview-fullscreen" v-show-delay="showPreview" @click="showPreview=false">
            <div class="image-content" :style="{backgroundImage:`url(${uploadedFile&&uploadedFile.url || noImagePlaceholder})`}">
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'i-uploader',
    props: {
        "value": { type: [String,Object] },
        "type": { type: String, default: 'file' }, //image
        "label": { type: String },
        "containerMode": { type: Boolean, default: false }
    },
    methods: {
        upload() {
            this.input.click();
        },
        zoomIn(){

        }
    },
    mounted() {
        let self = this;
        let { type } = this;
        let input = document.createElement("input");
        if(type === 'image'){
            self.uploadedFile = {url: this.value, ext:'jpg'}
        } else {
            self.uploadedFile = this.value;
        }
        input.type = "file";
        this.input = input;
        input.addEventListener("change", (e) => {

            let file = e.target.files[0];
            var formData = new FormData();
            formData.append("file", file);

            var request = new XMLHttpRequest();
            request.open("POST", "//" + location.hostname + (location.port ? ':' + location.port : '') + "/api/v1/upload");
            request.withCredentials = true;

            request.onload = function(oEvent) {
                if (request.status == 200) {
                    console.log("UPLOADED!", request.response);
                    let data = JSON.parse(request.response);
                    let { url, name, ext, size } = data;
                    self.uploadedFile = { url, name, ext, size };
                    if (type === 'image') {
                        self.imageSrc = url;
                        self.$emit('input', url);
                    } else if(type === 'file'){
                        self.$emit('input', url);
                    } else {
                        self.$emit('input', self.uploadedFile);
                    }
                } else {
                    console.log("ERROR ON UPLOAD")
                }
            };
            request.send(formData);
        });
    },

    data() {
        return {
            showPreview:false,
            noImagePlaceholder: require("../../assets/img/image.svg"),
            uploadedFile: false,
            fileIcons: {
                xls: "file-excel",
                xlsx: "file-excel",
                pdf: "file-pdf",
                doc: "file-word",
                docx: "file-word",
                ppt: "file-powerpoint",
                pptx: "file-powerpoint",
                mp4: "file-video",
                wmv: "file-video",
                avi: "file-video",
                mov: "file-video",
                mkv: "file-video",
                mp3: "file-audio",
                acc: "file-audio",
                flac: "file-audio",
                wav: "file-audio",
                zip: "file-archive",
                rar: "file-archive",
                "7z": "file-archive",
                js: "file-code",
                html: "file-code",
                cpp: "file-code",
                py: "file-code",
                ts: "file-code",
                java: "file-code",
                jpg: "file-image",
                jpeg: "file-image",
                png: "file-image",
                gif: "file-image",
                bmp: "file-image",
                tiff: "file-image"
            }
        }
    },
    computed: {}
}
</script>
<style lang="css" scoped>
.image-preview {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid lightgrey;
    border-radius: 4px;
    margin: 4px auto;
    padding: 2px;
    width: 120px;
    height: 120px;
}
.fader{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    padding-top:38px;
    opacity: 0.1;
    transition: 0.3s all ease;
}

.fader:hover{
    opacity: 1;
}
.img-ctrl{
    cursor: pointer;
    color:white;
}
.img-ctrl:hover{
    color:lightgrey;
}

.image-preview-fullscreen{
    width:100%;
    height:100%;
    position: fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.75);
    z-index:1001;
    opacity: 0;
    transition: 0.3s all ease;
}

.image-preview-fullscreen.shown{
    opacity: 1;
}
.image-content{
    width:80%;
    height:80%;
    position: absolute;
    top:10%;
    left:10%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: white;
    border-radius: 8px;
}

.uploaded-file{
    padding:8px 4px;
    border:1px solid lightgrey;
    background: whitesmoke;
    border-radius: 4px;

}
.uploaded-file a{
    
    text-decoration: none;
}
</style>